import { Link } from "wouter";
import { Skeleton } from "@sfc/ui";
import { RouteScroller } from "@client/components/utils/RouteScroller";
import { ApplicationLoading } from "@client/components/applications/ApplicationLoading";

export function TeamsLoading({
  admin,
  detail = false,
}: {
  admin: boolean;
  detail?: boolean;
}) {
  return (
    <RouteScroller>
      <main
        className={`mx-auto w-full px-4 py-8 md:px-8 ${detail ? "max-w-[1200px]" : "max-w-3xl"}`}
      >
        <span hidden data-application-theme="green" />
        {detail && (
          <Link
            href={admin ? "~/admin/teams" : "~/teams"}
            className="body-sm text-primary"
          >
            {admin ? "All Teams" : "My Teams"}
          </Link>
        )}
        <header className={detail ? "my-6 flex flex-col gap-2" : "mb-6"}>
          {detail ? (
            <>
              <Skeleton
                className="h-9 w-64 max-w-full motion-reduce:animate-none"
                aria-hidden="true"
              />
              <Skeleton
                className="h-6 w-24 motion-reduce:animate-none"
                aria-hidden="true"
              />
            </>
          ) : (
            <>
              <h1 className="heading-xl">
                {admin ? "Manage Teams" : "My Teams"}
              </h1>
              <p className="mt-2 body-md text-muted-foreground">
                {admin
                  ? "View and manage teams across S-Process."
                  : "To apply for a funding round, create a team for your organization or project. Then start an application and invite others to work on it with you. Applying on your own? Your team can be just you."}
              </p>
            </>
          )}
        </header>
        <div
          className={`mb-6 flex h-11 items-center gap-6 ${detail ? "border-b border-border" : "justify-between"}`}
          aria-hidden="true"
        >
          <Skeleton className="h-5 w-28 motion-reduce:animate-none" />
          <Skeleton className="h-5 w-28 motion-reduce:animate-none" />
        </div>
        <ApplicationLoading
          label={detail ? "Loading team" : "Loading teams"}
          rows={2}
        />
      </main>
    </RouteScroller>
  );
}
